import { Component, NgZone, OnInit } from '@angular/core';
import { error } from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/confirmation-dialog/confirmation-dialog.service';
import { HttpService } from 'src/app/services/http.service';
import { URLUtils } from 'src/app/urlUtils';

declare var Razorpay: any;

interface SubscriptionCheckoutResponse {
  subscription_id: string;
  checkout_options: any;
}

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss'],
  standalone: false
})
export class SubscriptionComponent implements OnInit {

  plans: any[] = [];
  errorMessage = '';
  loadingPlanId = '';
  currentUserId = localStorage.getItem('prof_id');
  isSoloCategory = false;
  currentPlanId: string = '';
  userId: any;
  profuid = localStorage.getItem('profuid')
  role: string = '';
  showDowngradeModal = false;
  downgradeMessage = '';
  users_allowed: any;

  constructor(
    private http: HttpService,
    private spinner: NgxSpinnerService,
    private ngZone: NgZone, private toast: ToastrService,
    private confirmationDialogService: ConfirmationDialogService,
  ) { }

  ngOnInit(): void {
    this.getPlans();
    const category = localStorage.getItem('category');
    this.isSoloCategory = category?.toLowerCase() === 'solo';
    console.log(this.isSoloCategory)
  }

  getPlans(): void {

    this.spinner.show();

    this.http.sendGetRequest(URLUtils.paymentPlan).subscribe({

      next: (res: any) => {

        this.spinner.hide();
        this.userId = res.data.id;

        // Keep 'isPaidSub' in sync with the latest subscription status
        // returned by the plans API (same pattern used in login/registerotp)
        localStorage.setItem('isPaidSub', JSON.stringify(res?.data?.is_active));
          
        // Update CurrentPlan in localStorage
        localStorage.setItem('plan', res?.data?.currentPlan);


        const apiPlans = res?.data?.plans || [];

        this.plans = apiPlans.map((plan: any) => ({

          ...plan,

          //users_allowed: 1,

          description:
            plan.name === 'Basic'
              ? 'Ideal for lawyers starting with Lex-Z Marketplace.'
              : plan.name === 'Standard'
                ? 'Best choice for growing law firms.'
                : plan.name === 'Pro'
                  ? 'Complete Lawyer Suite + Marketplace.'
                  : plan.description || ''

        }));

        console.log('Plans from API:', this.plans);

      },

      error: (err: any) => {

        this.spinner.hide();

        this.errorMessage =
          'Failed to load plans. Please refresh.';

        console.error('Failed to load plans:', err);

      }

    });
  }

  getPlanDescription(plan: any, index: number): string {

    if (plan?.description) {
      return plan.description;
    }

    const descriptions = [
      'Ideal for lawyers starting with Lex-Z Marketplace.',
      'Best choice for growing law firms.',
      'Complete Lawyer Suite + Marketplace.'
    ];

    return descriptions[index] || '';
  }

  isCurrentPlan(plan: any): boolean {

    return plan.id === this.currentPlanId;

  }

  // increaseUsers(plan: any): void {
  //   plan.users_allowed++;
  // }
  // decreaseUsers(plan: any): void {
  //   if (plan.users_allowed > 1) {
  //     plan.users_allowed--;
  //   }
  // }
  increaseUsers(plan: any): void {
    plan.users_allowed = (Number(plan.users_allowed) || 1) + 1;
  }
  decreaseUsers(plan: any): void {
    const currentUsers = Number(plan.users_allowed) || 1;

    if (currentUsers > 1) {
      plan.users_allowed = currentUsers - 1;
    }
  }

  getPlanActionId(plan: any): string {
    return String(
      plan?.id ??
      plan?.key ??
      plan?.planId ??
      ''
    );
  }

  onSubscribe(plan: any): void {
    //console.log('Selected plan:', plan);

    if (!this.currentUserId) {
      this.toast.error('Please log in to subscribe.');
      return;
    }

    const actionType = plan?.action?.type;
    this.users_allowed = plan.users_allowed;
    console.log('users_allowed after update:', this.users_allowed);

    if (
      actionType !== 'SUBSCRIBE' &&
      actionType !== 'UPGRADE' &&
      actionType !== 'DOWNGRADE'
    ) {
      this.toast.error('Invalid subscription action.');
      return;
    }

    // Only clicked button shows Processing...
    this.loadingPlanId = this.getPlanActionId(plan);

    // SUBSCRIBE
    if (actionType === 'SUBSCRIBE') {

      const payload = {
        plan_id: plan.planId,
        user_id: this.currentUserId,
        users_allowed: this.users_allowed || 1,
      };

      this.http
        .sendIMPostRequest(URLUtils.Subscription, payload)
        .subscribe({
          next: (res: any) => {
            console.log('Subscribe response:', res);

            this.openSubscriptionCheckout(res, plan);
          },

          error: (err: any) => {
            console.error('Subscribe error:', err);

            this.loadingPlanId = '';

            this.toast.error(
              err?.error?.msg ||
              err?.error?.data?.msg ||
              'Could not initiate subscription.'
            );
          }
        });

      return;
    }

    // UPGRADE
    if (actionType === 'UPGRADE') {
      // this.toast.info('Upgrade process initiated...');

      const payload = {
        new_plan: plan.key,
        users_allowed: this.users_allowed || 1,
      };

      console.log('====================================');
      console.log('UPGRADE CLICKED');
      console.log('Plan:', plan);
      console.log('Plan key:', plan.key);
      console.log('Plan ID:', plan.planId);
      console.log('Plan price:', plan.price);
      console.log('Expected amount:', plan.price * 100);
      console.log('Upgrade payload:', payload);
      console.log('====================================');

      this.http.sendPostRequest(URLUtils.PlanUpgrade, payload).subscribe({
        next: (res: any) => {
          console.log(
            '========== UPGRADE API RESPONSE =========='
          );

          console.log(
            'Full response:',
            JSON.stringify(res, null, 2)
          );

          console.log(
            'Upgrade request ID:',
            res?.upgrade_request_id
          );

          console.log(
            'Order ID:',
            res?.checkout_options?.order_id
          );

          console.log(
            'Amount returned by backend:',
            plan.price
          );

          console.log(
            'Currency returned by backend:',
            res?.checkout_options?.currency
          );

          console.log(
            'Prefill:',
            res?.checkout_options?.prefill
          );

          console.log(
            '=========================================='
          );

          this.openProrationCheckout(
            res,
            plan
          );
        },

        error: (err: any) => {

          console.error(
            'Upgrade API error:',
            err
          );

          this.loadingPlanId = '';

          this.toast.error(
            err?.error?.msg ||
            err?.error?.data?.msg ||
            'Could not initiate upgrade.'
          );
        }
      });

      return;
    }

    // DOWNGRADE
    if (actionType === 'DOWNGRADE') {

      const payload = {
        new_plan: plan.key
      };

      console.log('Downgrade payload:', payload);

      this.http
        .sendPostRequest(URLUtils.PlanDownGrade, payload)
        .subscribe({

          next: (res: any) => {

            console.log('Downgrade response:', res);

            // Stop Processing...
            this.loadingPlanId = '';

            // Get message from API
            this.downgradeMessage =
              res?.msg ||
              'Downgrade request submitted successfully.';

            // Open custom modal
            this.showDowngradeModal = true;

            // Refresh plans
            this.getPlans();
          },

          error: (err: any) => {

            console.error('Downgrade error:', err);

            this.loadingPlanId = '';

            this.downgradeMessage =
              err?.error?.msg ||
              err?.error?.data?.msg ||
              'Could not initiate downgrade.';

            this.showDowngradeModal = true;
          }
        });

      return;
    }

  }

showUpgradeSuccessDialog(response: any, paymentResponse: any, plan: any): void {
  this.confirmationDialogService.confirm(
    'Proration Payment Successful!', // title
    `Click continue to securely register your automatic recurring setup (eMandate) for new plan ${plan?.name}.`, // message
    false,        // displayCancelButton
    'Continue',   // btnOkText
    'Cancel',     // btnCancelText
    true,         // isSuccess
    'sm'          // dialogSize
  ).then((confirmed: boolean) => {
    if (confirmed) {
      
      this.authorizeUpgrade(
        response,
        paymentResponse,
        plan
      );
    } else {
      this.toast.info('Process paused. Please finish eMandate execution to implement changes.');
      this.getPlans();
    }
  }).catch(() => {
    // Gracefully handles dialog window dismissals (backdrop click, escape, or close 'X' button)
    this.toast.info('Process paused. Please finish eMandate execution to implement changes.');
    this.getPlans();
  });
}

openProrationCheckout(
  response: any,
  plan: any
): void {

  console.log('response', response)
  console.log('plan',plan)

  const checkoutOptions =
    response?.checkout_options;

  if (!checkoutOptions) {
    this.loadingPlanId = '';
    this.toast.error(
      'Payment details could not be loaded.'
    );
    return;
  }

  console.log('Plan price:', plan.price);
  console.log(
    'Expected full plan amount:',
    plan.price * 100
  );

  console.log(
    'Backend order ID:',
    checkoutOptions.order_id
  );

  console.log(
    'Backend amount:',
    checkoutOptions.amount
  );

  const options: any = {

    // Use backend checkout options
    ...checkoutOptions,

    handler: (paymentResponse: any) => {

      console.log(
        'Proration payment success:',
        paymentResponse
      );

      this.ngZone.run(() => {

        // this.authorizeUpgrade(
        //   response,
        //   paymentResponse,
        //   plan
        // );
        this.toast.success("Plan upgraded successfully.")
        this.getPlans();

        // this.showUpgradeSuccessDialog(response, paymentResponse, plan);

      });
    },

    modal: {
      ondismiss: () => {

        this.ngZone.run(() => {

          this.loadingPlanId = '';

          this.toast.error(
            'Upgrade payment cancelled.'
          );

        });
      }
    }
  };

  try {

    const rzp = new Razorpay(options);

    rzp.on(
      'payment.failed',
      (failResponse: any) => {

        this.ngZone.run(() => {

          this.loadingPlanId = '';

          this.toast.error(
            failResponse?.error?.description ||
            'Payment failed.'
          );

        });
      }
    );

    rzp.open();

  } catch (error) {

    console.error(
      'Failed to open Razorpay:',
      error
    );

    this.loadingPlanId = '';

    this.toast.error(
      'Unable to open payment gateway.'
    );
  }
}

authorizeUpgrade(
  response: any,
  paymentResponse: any,
  plan: any
): void {
  console.log('response',response)
  console.log('paymentResponse',paymentResponse)
  console.log('plan',plan)


  const payload = {
    plan_id: plan.planId,
    user_id: this.currentUserId,
    upgrade: true,
    users_allowed: this.users_allowed || 1,
    request_id: response.upgrade_request_id
  };

  console.log('Payload:', payload);

  this.http.sendIMPostRequest(URLUtils.Subscription,payload).subscribe({next: (authResponse: any) => {
        console.log('UPGRADE AUTHORIZE RESPONSE:', authResponse);
        //First Razorpay payment is complete.
        //Backend now returns eMandate
        //checkout options.

        // this.getPlans();
        this.openEmandateCheckout(authResponse,plan);
      },

      error: (err: any) => {
        console.error('Upgrade authorization failed:',err);

        this.loadingPlanId = '';

        this.toast.error(
          err?.error?.msg ||
          err?.error?.data?.msg ||
          'Failed to authorize upgrade.'
        );
      }

    });
}

  openEmandateCheckout(authResponse: any, plan: any): void {
   console.log('Opening eMandate checkout:',authResponse);

    const paymentData = authResponse?.data || authResponse;
    const checkoutOptions = paymentData?.checkout_options;

    if (!checkoutOptions) {
      console.error('eMandate checkout_options missing:', authResponse);
      this.loadingPlanId = '';
      this.toast.error('eMandate payment details could not be loaded.');
      return;
    }

    const options: any = {
      ...checkoutOptions,
      handler: (paymentResponse: any) => {

        console.log('eMandate authorization successful:', paymentResponse);

        this.ngZone.run(() => {
           // Second Razorpay completed.
           // NOW create the subscription.
            this.toast.success("Emandate successfull for new plan")
            this.getPlans();
          // this.createSubscriptionAfterUpgrade(paymentData,
          //   paymentResponse, plan
          // );
        });
      },

      modal: {
        ondismiss: () => {
          this.ngZone.run(() => {
            console.log('eMandate checkout dismissed');
            this.loadingPlanId = '';
            //this.toast.info('Upgrade authorization cancelled.');
          });
        }
      }
    };

    console.log('eMandate Razorpay options:',options);

    try {

      const rzp = new Razorpay(options);

      rzp.on(
        'payment.failed',
        (failResponse: any) => {

          this.ngZone.run(() => {

            console.error(
              'eMandate authorization failed:',
              failResponse?.error
            );

            this.loadingPlanId = '';

            this.toast.error(
              failResponse?.error?.description ||
              'eMandate authorization failed.'
            );
          });
        }
      );

      rzp.open();

    } catch (error) {

      console.error(
        'Failed to open eMandate Razorpay:',
        error
      );

      this.loadingPlanId = '';

      this.toast.error(
        'Unable to open authorization payment gateway.'
      );
    }
  }

  openDowngradeCheckout(
    response: any,
    plan: any
  ): void {

    console.log('Opening downgrade checkout:', response);

    const paymentData = response?.data || response;

    const checkoutOptions =
      paymentData?.checkout_options;

    if (!checkoutOptions) {

      console.error(
        'Downgrade checkout_options missing:',
        response
      );

      this.loadingPlanId = '';

      this.toast.error(
        'Payment details could not be loaded.'
      );

      return;
    }

    const options: any = {

      // IMPORTANT:
      // Use the complete checkout options
      // returned by the backend.
      ...checkoutOptions,

      handler: (paymentResponse: any) => {

        console.log(
          'Downgrade payment successful:',
          paymentResponse
        );

        this.ngZone.run(() => {

          this.loadingPlanId = '';

          this.toast.success(
            'Downgrade payment completed successfully.'
          );

          // Refresh plans
          this.getPlans();
        });
      },

      modal: {

        ondismiss: () => {

          this.ngZone.run(() => {

            console.log(
              'Downgrade checkout dismissed'
            );

            this.loadingPlanId = '';

            this.toast.error(
              'Payment cancelled.'
            );
          });
        }
      }
    };

    console.log(
      'Downgrade Razorpay options:',
      options
    );

    try {

      const rzp = new Razorpay(options);

      rzp.on(
        'payment.failed',
        (failResponse: any) => {

          this.ngZone.run(() => {

            console.error(
              'Downgrade payment failed:',
              failResponse?.error
            );

            this.loadingPlanId = '';

            this.toast.error(
              failResponse?.error?.description ||
              'Payment failed.'
            );
          });
        }
      );

      rzp.open();

    } catch (error) {

      console.error(
        'Failed to open downgrade Razorpay:',
        error
      );

      this.loadingPlanId = '';

      this.toast.error(
        'Unable to open payment gateway.'
      );
    }
  }


  createSubscriptionAfterUpgrade(
    authResponse: any,
    paymentResponse: any,
    plan: any
  ): void {

    console.log(
      'Creating subscription after upgrade payment...'
    );

    const payload = {

      plan_id:
        plan?.planId ||
        plan?.id,

      user_id:
        this.currentUserId,

      upgrade_request_id:
        authResponse?.upgrade_request_id,

      razorpay_subscription_id:
        paymentResponse?.razorpay_subscription_id
    };

    console.log(
      'Create subscription payload:',
      payload
    );

    this.http
      .sendIMPostRequest(
        URLUtils.Subscription,
        payload
      )
      .subscribe({

        next: (res: any) => {

          console.log(
            'Subscription created successfully:',
            res
          );

          this.loadingPlanId = '';

          this.toast.success(
            'Plan upgraded successfully.'
          );

          // Reload plans so the new plan becomes CURRENT
          this.getPlans();
        },

        error: (err: any) => {

          console.error(
            'Create subscription failed:',
            err
          );

          this.loadingPlanId = '';

          this.toast.error(
            err?.error?.msg ||
            err?.error?.data?.msg ||
            'Payment completed, but subscription creation failed.'
          );
        }
      });
  }

  openSubscriptionCheckout(
    response: any,
    plan: any
  ): void {

    console.log(
      'Opening subscription checkout:',
      response
    );

    const paymentData =
      response?.data || response;

    const checkoutOptions =
      paymentData?.checkout_options;

    if (!checkoutOptions) {

      console.error(
        'Subscription checkout_options missing:',
        response
      );

      this.loadingPlanId = '';

      this.toast.error(
        'Payment details could not be loaded.'
      );

      return;
    }

    const options: any = {

      ...checkoutOptions,

      handler: (paymentResponse: any) => {

        console.log(
          'Subscription payment successful:',
          paymentResponse
        );

        this.ngZone.run(() => {

          this.loadingPlanId = '';

          this.toast.success(
            'Subscription activated successfully.'
          );

          this.getPlans();
        });
      },

      modal: {

        ondismiss: () => {

          this.ngZone.run(() => {

            this.loadingPlanId = '';

            this.toast.error(
              'Payment cancelled.'
            );
          });
        }
      }
    };

    try {

      const rzp = new Razorpay(options);

      rzp.on(
        'payment.failed',
        (response: any) => {

          this.ngZone.run(() => {

            this.loadingPlanId = '';

            this.toast.error(
              response?.error?.description ||
              'Payment failed.'
            );
          });
        }
      );

      rzp.open();

    } catch (error) {

      console.error(
        'Failed to open Razorpay:',
        error
      );

      this.loadingPlanId = '';

      this.toast.error(
        'Unable to open payment gateway.'
      );
    }
  }

  onStartFreeTrial(): void {
    console.log('Free trial clicked');
  }

  onBookDemo(): void {
    console.log('Book a Free Demo clicked');
  }

  formatAmount(paise: number): string {
    return `₹${(paise / 100).toLocaleString('en-IN')}`;
  }

  getPlanFeatures(plan: any, index: number): string[] {

    // If features are coming from API
    if (Array.isArray(plan?.features) && plan.features.length > 0) {
      return plan.features;
    }

    // Fallback features
    const features: string[][] = [
      [
        'Marketplace Profile',
        'Appointment Booking',
        'Search Visibility'
      ],
      [
        'Instant Call',
        'Higher Marketplace Visibility'
      ],
      [
        'Complete Lawyer Suite',
        'Document Editor',
        'Meetings',
        'Invoices',
        'Groups',
        'Audit Logs',
        'Instant Call'
      ]
    ];

    return features[index] || [];
  }

  getDisplayPlanName(name: string): string {
    switch (name?.toLowerCase()) {
      case 'basic':
        return 'Starter';

      case 'standard':
        return 'Professional';

      case 'pro':
        return 'Premium';

      default:
        return name;
    }
  }

  // getPlanPrice(plan: any): string {

  //   const amount = this.getTotalAmount(plan);

  //   if (amount === null || amount === undefined || isNaN(amount)) { return '₹0'; }

  //   return `₹${amount.toLocaleString('en-IN')}`;
  // }
  getPlanPrice(plan: any): string {
    const users = Number(plan?.users_allowed) || 1;
    const pricePerUser = Number(plan?.price) || 0;

    const totalAmount = pricePerUser * users;

    return `₹${totalAmount.toLocaleString('en-IN')}`;
  }

  getTotalAmount(plan: any): number {
    const amount = Number(
      plan.amount ??
      plan.price ??
      plan.plan_amount ??
      plan.monthly_amount ??
      plan.unit_amount);

    return isNaN(amount) ? 0 : amount;
  }

  closeDowngradeModal(): void {
  this.showDowngradeModal = false;
  this.downgradeMessage = '';
}
}